<div class="bg-m1 flex h-full cursor-default flex-col">
  <div class="mx-6 mb-6 mt-8 flex h-2 flex-grow flex-col">
    <div class="flex h-11 flex-row items-center justify-start">
      <div
        data-cy="projectConnectionsTitle"
        class="text-s1 flex select-none text-2xl font-semibold"
        >{{ pageTitle }}
      </div>

      <div
        class="ml-10"
        tp="Admin role required"
        [tpIsEnabled]="isAdmin === false"
      >
        <button
          data-cy="projectConnectionsAddConnectionButton"
          class="text-m0 h-11 flex-shrink-0 select-none rounded px-5 py-2 text-base font-medium focus:outline-none"
          type="submit"
          [ngClass]="{
            'bg-m600': isAdmin === true,
            'bg-s400 cursor-default': isAdmin === false
          }"
          (click)="addConnection()"
          [disabled]="isAdmin === false"
          >Add Connection</button
        >
      </div>
    </div>

    <div class="bg-m0 mt-6 flex-grow overflow-auto rounded shadow">
      <ng-scrollbar
        [orientation]="'auto'"
        [visibility]="'hover'"
        [appearance]="'compact'"
        *ngIf="connections?.length > 0"
      >
        <div class="text-s1 mx-5 mt-8">
          <table class="divide-s500 min-w-full divide-y">
            <thead>
              <tr class="h-12 text-sm">
                <th class="select-none text-left"></th>
                <th class="select-none text-left"></th>
                <th class="select-none text-left">Connection Name</th>
                <th class="select-none text-left">Environment</th>
                <th class="select-none text-left">Type</th>
                <th class="select-none text-left">SSL</th>
                <th class="select-none text-left">Host / API Base URL</th>
                <th class="select-none text-left">Port</th>
                <th class="select-none text-left">Database</th>
                <th class="select-none text-left">User</th>
                <th class="select-none text-left">Extra</th>
                <th></th>
              </tr>
            </thead>

            <tbody class="divide-s300 divide-y text-base">
              <tr *ngIf="connections?.length === 0"> </tr>

              <tr *ngFor="let connection of connections" class="h-16">
                <td class="w-[100px]">
                  <div
                    class="w-fit"
                    tp="Admin role required"
                    [tpIsEnabled]="isAdmin === false"
                  >
                    <button
                      data-cy="projectConnectionsDeleteButton"
                      class="ml-5 h-9 w-9 rounded focus:outline-none"
                      [ngClass]="{
                        'text-s1 hover:bg-m200': isAdmin === true,
                        'text-s400 cursor-default': isAdmin === false
                      }"
                      [disabled]="isAdmin === false"
                      (click)="deleteConnection(connection)"
                    >
                      <div class="flex justify-center">
                        <m-trash-icon></m-trash-icon>
                      </div>
                    </button>
                  </div>
                </td>

                <td class="w-24">
                  <div
                    class="w-fit"
                    tp="Admin role required"
                    [tpIsEnabled]="isAdmin === false"
                  >
                    <button
                      data-cy="projectConnectionsEditButton"
                      (click)="editConnection(connection)"
                      class="h-9 select-none rounded border px-3 text-base leading-3 shadow-sm focus:outline-none"
                      [ngClass]="{
                        'border-s400 text-s500 hover:bg-s100': isAdmin === true,
                        'border-s300 text-s400 cursor-default':
                          isAdmin === false
                      }"
                      [disabled]="isAdmin === false"
                      >Edit</button
                    >
                  </div>
                </td>

                <td class="w-48">{{ connection.connectionId }}</td>

                <td class="w-48">{{ connection.envId }}</td>

                <td class="w-48">{{ connection.type }} </td>

                <td
                  class="w-48"
                  [ngClass]="{
                    'text-s400':
                      (connection.type === typeApi &&
                        !!connection.options.storeApi?.baseUrl) ||
                      (connection.type === typeGoogleApi &&
                        !!connection.options.storeGoogleApi?.baseUrl)
                  }"
                >
                  {{
                    (connection.type === typeApi &&
                      !!connection.options.storeApi?.baseUrl) ||
                    (connection.type === typeGoogleApi &&
                      !!connection.options.storeGoogleApi?.baseUrl)
                      ? ''
                      : ((connection.type === typePostgreSQL
                          ? connection.options.postgres?.isSSL
                          : ''
                        ).toString() | capitalize)
                  }}
                </td>

                <td data-cy="projectConnectionsHost" class="w-96">
                  {{
                    (connection.type === typePostgreSQL
                      ? connection.options.postgres?.host
                      : connection.type === typeMySQL
                        ? connection.options.mysql?.host
                        : connection.type === typeTrino
                          ? connection.options.trino?.server
                          : connection.type === typePresto
                            ? connection.options.presto?.server
                            : connection.type === typeDatabricks
                              ? connection.options.databricks?.host
                              : undefined) ||
                      (connection.type === typeApi
                        ? connection.options.storeApi?.baseUrl
                        : connection.type === typeGoogleApi
                          ? connection.options.storeGoogleApi?.baseUrl
                          : undefined)
                  }}
                  <span
                    *ngIf="
                      (connection.type === typePostgreSQL &&
                        connection.options.postgres?.internalHost) ||
                      (connection.type === typeMySQL &&
                        connection.options.mysql?.internalHost) ||
                      (connection.type === typeTrino &&
                        connection.options.trino?.internalServer) ||
                      (connection.type === typePresto &&
                        connection.options.presto?.internalServer) ||
                      (connection.type === typeDatabricks &&
                        connection.options.databricks?.internalHost)
                    "
                    class="text-s400 ml-2"
                    >{{
                      connection.type === typePostgreSQL
                        ? connection.options.postgres?.internalHost
                        : connection.type === typeMySQL
                          ? connection.options.mysql?.internalHost
                          : connection.type === typeTrino
                            ? connection.options.trino?.internalServer
                            : connection.type === typePresto
                              ? connection.options.presto?.internalServer
                              : connection.type === typeDatabricks
                                ? connection.options.databricks?.internalHost
                                : undefined
                    }}</span
                  >
                </td>

                <td class="w-48">
                  {{
                    connection.type === typePostgreSQL
                      ? connection.options.postgres?.port
                      : connection.type === typeMySQL
                        ? connection.options.mysql?.port
                        : connection.type === typePresto
                          ? connection.options.presto?.port
                          : undefined
                  }}
                  <span
                    *ngIf="
                      (connection.type === typePostgreSQL &&
                        connection.options.postgres?.internalPort) ||
                      (connection.type === typeMySQL &&
                        connection.options.mysql?.internalPort) ||
                      (connection.type === typePresto &&
                        connection.options.presto?.internalPort)
                    "
                    class="text-s400 ml-2"
                    >{{
                      connection.type === typePostgreSQL
                        ? connection.options.postgres?.internalPort
                        : connection.type === typeMySQL
                          ? connection.options.mysql?.internalPort
                          : connection.type === typePresto
                            ? connection.options.presto?.internalPort
                            : undefined
                    }}</span
                  >
                </td>

                <td class="w-48"
                  >{{
                    connection.type === typePostgreSQL
                      ? connection.options.postgres?.database
                      : connection.type === typeMySQL
                        ? connection.options.mysql?.database
                        : connection.type === typeTrino
                          ? connection.options.trino?.catalog
                          : connection.type === typePresto
                            ? connection.options.presto?.catalog
                            : connection.type === typeSnowFlake
                              ? connection.options.snowflake?.database
                              : connection.type === typeMotherDuck
                                ? connection.options.motherduck?.database
                                : connection.type === typeDatabricks
                                  ? connection.options.databricks
                                      ?.defaultCatalog
                                  : undefined
                  }}
                </td>

                <td class="w-48"
                  >{{
                    connection.type === typePostgreSQL
                      ? connection.options.postgres?.username
                      : connection.type === typeMySQL
                        ? connection.options.mysql?.user
                        : connection.type === typeTrino
                          ? connection.options.trino?.user
                          : connection.type === typePresto
                            ? connection.options.presto?.user
                            : connection.type === typeSnowFlake
                              ? connection.options.snowflake?.username
                              : undefined
                  }}
                </td>

                <td>
                  <div
                    class="flex-col"
                    *ngIf="
                      connection.type === typeBigQuery ||
                      connection.type === typeGoogleApi
                    "
                  >
                    <div>
                      <span class="font-medium">Project: </span>
                      <span class="text-g700">
                        {{
                          connection.type === typeBigQuery
                            ? connection.options.bigquery?.googleCloudProject
                            : connection.type === typeGoogleApi
                              ? connection.options.storeGoogleApi
                                  ?.googleCloudProject
                              : undefined
                        }}
                      </span>
                    </div>
                    <div>
                      <span class="font-medium">Client Email: </span>
                      <span class="text-g700">
                        {{
                          connection.type === typeBigQuery
                            ? connection.options.bigquery
                                ?.googleCloudClientEmail
                            : connection.type === typeGoogleApi
                              ? connection.options.storeGoogleApi
                                  ?.googleCloudClientEmail
                              : undefined
                        }}
                      </span>
                    </div>
                    <div *ngIf="connection.type === typeBigQuery">
                      <span class="mt-2 font-medium"
                        >Query Size Limit, gb:
                      </span>
                      <span class="text-g700">
                        {{
                          connection.options.bigquery?.bigqueryQuerySizeLimitGb
                        }}
                      </span>
                    </div>
                  </div>

                  <div
                    class="flex-col"
                    *ngIf="connection.type === typeSnowFlake"
                  >
                    <div>
                      <span class="font-medium">Account: </span>
                      <span class="text-g700">
                        {{ connection.options.snowflake?.account }}
                      </span>
                    </div>
                    <div>
                      <span class="font-medium">Warehouse: </span>
                      <span class="text-g700">
                        {{ connection.options.snowflake?.warehouse }}
                      </span>
                    </div>
                  </div>

                  <div
                    class="flex-col"
                    *ngIf="
                      connection.type === typeTrino &&
                      !!connection.options.trino?.schema
                    "
                  >
                    <div>
                      <span class="font-medium">Schema: </span>
                      <span class="text-g700">
                        {{ connection.options.trino?.schema }}
                      </span>
                    </div>
                  </div>

                  <div
                    class="flex-col"
                    *ngIf="
                      connection.type === typePresto &&
                      !!connection.options.presto?.schema
                    "
                  >
                    <div>
                      <span class="font-medium">Schema: </span>
                      <span class="text-g700">
                        {{ connection.options.presto?.schema }}
                      </span>
                    </div>
                  </div>

                  <div
                    class="flex-col"
                    *ngIf="connection.type === typeDatabricks"
                  >
                    <div *ngIf="connection.options.databricks?.authType">
                      <span class="font-medium">Auth Type: </span>
                      <span class="text-g700">
                        {{ connection.options.databricks?.authType }}
                      </span>
                    </div>
                    <div *ngIf="connection.options.databricks?.path">
                      <span class="font-medium">Path: </span>
                      <span class="text-g700">
                        {{ connection.options.databricks?.path }}
                      </span>
                    </div>
                    <div *ngIf="connection.options.databricks?.defaultSchema">
                      <span class="font-medium">Schema: </span>
                      <span class="text-g700">
                        {{ connection.options.databricks?.defaultSchema }}
                      </span>
                    </div>
                    <div *ngIf="connection.options.databricks?.oauthClientId">
                      <span class="font-medium">OAuth Client ID: </span>
                      <span class="text-g700">
                        {{ connection.options.databricks?.oauthClientId }}
                      </span>
                    </div>
                  </div>

                  <div
                    class="flex-col"
                    *ngIf="
                      connection.type === typeGoogleApi &&
                      connection.options.storeGoogleApi?.googleAuthScopes
                        .length > 0
                    "
                  >
                    <div
                      class="font-medium"
                      [ngClass]="{
                        'mt-2':
                          !!connection.options.storeGoogleApi
                            ?.googleCloudClientEmail
                      }"
                      >Scopes:</div
                    >
                    <div
                      *ngFor="
                        let googleAuthScope of connection.options.storeGoogleApi
                          .googleAuthScopes
                      "
                    >
                      <span class="text-g700">
                        {{ googleAuthScope }}
                      </span>
                    </div>
                  </div>

                  <div
                    class="flex-col"
                    *ngIf="
                      (connection.type === typeApi &&
                        connection.options.storeApi?.headers?.length > 0) ||
                      (connection.type === typeGoogleApi &&
                        connection.options.storeGoogleApi?.headers?.length > 0)
                    "
                  >
                    <div
                      class="font-medium"
                      [ngClass]="{
                        'mt-2':
                          connection.type === typeGoogleApi &&
                          !!connection.options.storeGoogleApi
                            .googleCloudClientEmail
                      }"
                      >Headers:</div
                    >
                    <div
                      *ngFor="
                        let header of connection.type === typeApi
                          ? connection.options.storeApi?.headers
                          : connection.type === typeGoogleApi
                            ? connection.options.storeGoogleApi?.headers
                            : []
                      "
                    >
                      <span class="ml-5 font-medium">{{ header.key }}: </span>
                      <span class="text-g700">
                        {{ header.value }}
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-scrollbar>

      <div
        class="text-s1 flex h-full w-full select-none items-center justify-center text-xl"
        *ngIf="connections?.length === 0"
        >No connections</div
      >
    </div>
  </div>
</div>

<div *ngIf="projectId$ | async"></div>
<div *ngIf="isAdmin$ | async"></div>
<div *ngIf="connections$ | async"></div>
